import { uiBase } from '../env/constants'

export const lettersURL = uiBase +'letters'
